import { render } from "./SenderSelector.vue?vue&type=template&id=6bffdddd"
import script from "./SenderSelector.vue?vue&type=script&lang=js"
export * from "./SenderSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__